import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AppService } from "src/app/apps/app.service";
import { NotificationService } from "src/app/notifications/notification.service";
import { SessionService } from "src/app/session.service";
import { UiService } from "src/app/ui/ui.service";
import { AudienceContainerComponent } from "../audience-container/audience-container.component";

@Component({
  selector: "app-audience",
  templateUrl: "./audience.component.html",
  styleUrls: ["./audience.component.scss"],
})
export class AudienceComponent implements OnInit {
  @ViewChild(AudienceContainerComponent)
  audienceContainer!: AudienceContainerComponent;
  viewInit: boolean = false;
  private onComponentDestroy = new Subject();

  constructor(
    private activatedRoute: ActivatedRoute,
    private SessionService: SessionService,
    private AppService: AppService,
    private NotificationService: NotificationService,
    private Router: Router,
    private cdRef: ChangeDetectorRef,
    private uiService: UiService,
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.viewInit = true;
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  get currentAccount() {
    return this.SessionService.currentAccountValue!;
  }

  get currentApp() {
    return this.SessionService.currentAppValue!;
  }

  get saveDisabled() {
    const audienceFormInvalid = this.audienceContainer?.audienceForm.invalid;

    let traitFormsInvalid = false;
    for (let traitFormKey of Object.keys(this.audienceContainer?.traitForms)) {
      if (this.audienceContainer?.traitForms[traitFormKey].invalid) {
        traitFormsInvalid = true;
      }
    }

    return audienceFormInvalid || traitFormsInvalid;
  }

  get isNewAudience() {
    return this.audienceContainer.isNewAudience;
  }

  saveAudience() {
    this.uiService
      .waitForEvent(
        this.AppService.updateAudience(
          this.currentAccount.accountID,
          this.currentApp.id,
          this.audienceContainer?.audience.id,
          this.audienceContainer?.audienceDTO,
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(
        (audience) => {
          this.NotificationService.openSuccessSnackBar("Audience updated");
          this.Router.navigate(["list"], {
            relativeTo: this.activatedRoute.parent,
          });
        },
        (err) => {
          this.NotificationService.openErrorSnackBar("Error updating Audience");
        },
      );
  }

  createAudience() {
    this.uiService
      .waitForEvent(
        this.AppService.createAudience(
          this.currentAccount.accountID,
          this.currentApp.id,
          this.audienceContainer?.audienceDTO,
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(
        (audience) => {
          this.NotificationService.openSuccessSnackBar("Audience created");
          this.Router.navigate(["list"], {
            relativeTo: this.activatedRoute.parent,
          });
        },
        (err) => {
          this.NotificationService.openErrorSnackBar("Error creating Audience");
        },
      );
  }
}
